import { useLocale } from '../hooks/useLocale'
import styles from './Contact.module.css'

interface ContactData {
  title: string
  email: string
  emailLabel?: string
  description?: string
}

export default function Contact() {
  const { get, t } = useLocale()
  const data = get('contact') as ContactData | undefined

  if (!data?.email) return null

  const emailLabel = data.emailLabel || data.email
  const mailtoLink = `mailto:${data.email}`

  return (
    <section className={styles.contact} id="contact" aria-labelledby="contact-title">
      <div className={styles.container}>
        <h2 className={styles.title} id="contact-title">
          {data.title}
        </h2>
        {data.description && (
          <p className={styles.description}>{data.description}</p>
        )}
        <div className={styles.emailContainer}>
          <a
            href={mailtoLink}
            className={styles.emailLink}
            aria-label={`${t('contact.emailLabel') || 'Email'}: ${data.email}`}
          >
            {emailLabel}
          </a>
          <span className={styles.emailAddress}>{data.email}</span>
        </div>
      </div>
    </section>
  )
}
